/** Internal dependencies */
import { apiCall } from '../apiCall';
import { getCurrentFilters } from '../getCurrentFilters';
import { resetPagination } from '../resetPagination';

/**
 * Handler for our button filters, handles state changes on click.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Event} e
 * @returns void
 */
export function handleButtonFilters(e) {
    const target = e.target.closest('button');
    if (!target) {
        return;
    }

    e.preventDefault();
    const parent = target.closest('[data-ct-rest]');
    const isSelected = target.getAttribute('aria-pressed') === 'true';
    const isReset = target.dataset.ctFilter === 'reset';

    if (isReset) {
        // handled in its own listener
        return;
    } else if (isSelected) {
        // This means we want to remove the filter
        target.setAttribute('aria-pressed', 'false');
        target.classList.remove('active');
    } else {
        // Make the filter selected
        target.setAttribute('aria-pressed', 'true');
        target.classList.add('active');
    }

    resetPagination(parent);
    const currentFilters = getCurrentFilters(parent);
    apiCall(parent, currentFilters, true);
}
